(function () {
  document.addEventListener("rebuy:smartcart.ready", (event) => {
    const rebuySmartcart = event.detail.smartcart;
    document.addEventListener(
      "ajaxProduct:added",
      (event) => {
        if (rebuySmartcart) {
          event.stopImmediatePropagation();
          rebuySmartcart.show();
        }
      },
      true
    );
    document.addEventListener(
      "cart:open",
      (event) => {
        if (rebuySmartcart) {
          event.stopImmediatePropagation();
          event.preventDefault();
          rebuySmartcart.show();
        }
      },
      true
    );

    const style = document.createElement("style");
    style.textContent = `
            #CartDrawer {
                display: none !important;
            }
        `;
    document.head.appendChild(style);
    
  });
})();
